import { useEffect, useState } from "react";
import WordPressPageService from "services/wordpress-page.service";

const normalize = (value) =>
  value
    .replace(/<[^>]+>/g, "")
    .replace(/&amp;/gi, "&")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

const stripDuplicateTitle = (html, title) => {
  if (!title) return html;
  const match = html.match(/<h[1-6][^>]*>[\s\S]*?<\/h[1-6]>/i);
  if (match && normalize(match[0]) === normalize(title)) {
    return html.replace(match[0], "");
  }
  return html;
};

const WordPressContent = ({ slug, title }) => {
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    setHtml(null);
    setError(false);

    WordPressPageService.content(slug)
      .then((content) => {
        if (active) setHtml(stripDuplicateTitle(content, title));
      })
      .catch(() => {
        if (active) setError(true);
      });

    return () => {
      active = false;
    };
  }, [slug, title]);

  const renderBody = () => {
    if (error) {
      return (
        <p className="text-justify">
          Sorry, this content is currently unavailable. Please try again later.
        </p>
      );
    }

    if (html === null) {
      return (
        <div className="img-msg-container">
          <div className="img-msg" />
        </div>
      );
    }

    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  };

  return (
    <>
      {title && <h1 className="header-title">{title}</h1>}
      {renderBody()}
    </>
  );
};

export default WordPressContent;
